var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container is-fluid" },
      [
        _c(
          "b-field",
          { staticClass: "file" },
          [
            _c(
              "b-upload",
              {
                model: {
                  value: _vm.file,
                  callback: function ($$v) {
                    _vm.file = $$v
                  },
                  expression: "file",
                },
              },
              [
                _c(
                  "a",
                  { staticClass: "button is-info" },
                  [
                    _c("b-icon", { attrs: { icon: "file-csv" } }),
                    _c("span", [_vm._v("Pick movement file")]),
                  ],
                  1
                ),
              ]
            ),
            _vm.file
              ? _c("span", { staticClass: "file-name" }, [
                  _vm._v(" " + _vm._s(_vm.file.name) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "b-field",
          [
            _c(
              "b-checkbox",
              {
                model: {
                  value: _vm.launchProcess,
                  callback: function ($$v) {
                    _vm.launchProcess = $$v
                  },
                  expression: "launchProcess",
                },
              },
              [_vm._v(" Process it ")]
            ),
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "button is-primary",
            class: { "is-loading": _vm.isUploading },
            attrs: { disabled: !_vm.file },
            on: { click: _vm.upload },
          },
          [
            _c("b-icon", { attrs: { icon: "upload", size: "is-small" } }),
            _c("span", [_vm._v("Upload")]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }